import CustomerForm from 'pages/shared/CustomerForm'

import CustomerModel from 'models/Customer'

import { useSessionContext } from 'hooks/SessionContext'

import { SinglePanePage } from 'styles/shared'

const AddCustomer = () => {
  const { session: { readOnly, dealerId } } = useSessionContext()
  return (
    <SinglePanePage>
      <CustomerForm
        customer={new CustomerModel()}
        dealerId={dealerId}
        readOnly={readOnly}
        title="Add Customer"
        readOnlyMessage="Read-only view: can't create customer"
        displayDeleteButton={false}
      />
    </SinglePanePage>
  )
}

export default AddCustomer
